const trimTrailingSlash = (url: string): string => url.replace(/\/$/, '')

export const LYDIA_APP_DOWNLOAD_URL = 'https://lydia.onelink.me/YDzs/46jhkraf'

export const buildClaimTagDeeplink = (tag: string): string => {
	const base = trimTrailingSlash(process.env.REACT_APP_LYDIA_DEEPLINK_URL)
	return `${base}/claim?tag=${encodeURIComponent(tag)}`
}

export const buildLydiaAppUrl = (): string => {
	const base = trimTrailingSlash(process.env.REACT_APP_LYDIA_DEEPLINK_URL)
	return `${base}/app`
}
